import { Text } from '@joinrepublic/dls-ui-kit';

import { ISectorChipProps } from './types';

/**
 * A sector filter option. The design renders these as plain labels that turn
 * brand-coloured when selected — there is no pill, so this is a `Text` styled as
 * a button rather than a DLS `Tag`.
 */
export const SectorChip = ({
  label,
  slug,
  isSelected,
  onSelect,
  ...textProps
}: ISectorChipProps) => {
  return (
    <Text
      as="button"
      type="button"
      size="body-sm-md"
      color={isSelected ? 'brand.fg-primary' : 'neutral.fg-primary'}
      aria-pressed={isSelected}
      onClick={onSelect}
      data-testid="sector-chip"
      data-sector-slug={slug}
      // Labels must keep their intrinsic width, otherwise the row compresses to
      // fit and never overflows, so the scroll arrows never appear.
      flexShrink={0}
      whiteSpace="nowrap"
      _hover={{ color: 'brand.fg-primary' }}
      {...textProps}
    >
      {label}
    </Text>
  );
};
